export default function (LoadSaveService, $q, TranslateService) {
    var translateFn = TranslateService.instant;

    var ACTION_MSG = {
        createClaim: {
            error: {
                title: 'fnol.ho.config.FlowConfig.Error creating claim',
                message: 'fnol.ho.config.FlowConfig.An error occurred attempting to create homeowners claim.'
            },
            progress: {
                message: 'fnol.ho.config.FlowConfig.Creating homeowners draft claim...'
            }
        }
    };

    var ACTIONS = {
        createClaim: function createClaim(_ref) {
            var claim = _ref.value;
            return LoadSaveService.createClaim(claim);
        }
    };

    return function (step, junction) {
        junction('hoSuccess');

        junction('hoError');

        step('hoWhat', true).onNext.doAction(function (model, extraArgs) {
            if (model.claimNumber.value || extraArgs.miscellaneous) {
                return $q.resolve(model);
            }
            return ACTIONS.createClaim(model);
        }, ACTION_MSG.createClaim, { forceUpdate: true }).thenBranch(function (_ref2) {
            var claim = _ref2.value;

            switch (claim.getLossCategory()) {
                case 'water':
                    return 'hoWaterDetails';
                case 'crime':
                    return 'hoCrimeDetails';
                case 'fire':
                    return 'hoFireDetails';
                default:
                    return 'hoError';
            }
        }, function () {
            return 'hoError';
        }).skipOnResumeIf(function (_ref3) {
            var claim = _ref3.value;
            return claim.policy;
        }).isValid(function (model, extraArgs) {
            return extraArgs.miscellaneous || model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return translateFn('fnol.wizard.step.ho.What');
        });

        step('hoFireDetails').onNext.goTo('hoSuccess').skipOnResumeIf(function (_ref4) {
            var claim = _ref4.value;
            return claim.lossCause === 'fire';
        }).label(function () {
            return translateFn('fnol.wizard.step.ho.Details');
        });

        step('hoWaterDetails').onNext.goTo('hoSuccess').skipOnResumeIf(function (_ref5) {
            var claim = _ref5.value;
            return claim.lossCause === 'waterdamage';
        }).label(function () {
            return translateFn('fnol.wizard.step.ho.Details');
        });

        step('hoCrimeDetails').onNext.goTo('hoSuccess').skipOnResumeIf(function (_ref6) {
            var claim = _ref6.value;
            return claim.lossCause === 'burglary';
        }).label(function () {
            return translateFn('fnol.wizard.step.ho.Details');
        });
    };
}